export default __webpack_public_path__ + "54461dac84aa4c491a72ea4dbf1004e4.png";